<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title" >Contato</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
			<form @submit.prevent="onSubmit()" v-show="!isloading">

				<section class="modal-card-body" >

						<div class="field">
							<div class="control">
								<input class="input" type="text" v-model="nome" required placeholder="Nome">
							</div>
						</div>

						<div class="field">
							<div class="control">
								<input class="input" type="email" v-model="email" required placeholder="E-mail">
							</div>
						</div>

						<div class="field">
							<div class="control">
								<input class="input" type="text" v-model="empresa" placeholder="Empresa">
							</div>
						</div>

						<div class="field">
							<div class="control">
								<textarea class="textarea" v-model="mensagem" required placeholder="Dúvida ou sugesão"></textarea>
							</div>
						</div>

						<div v-show="alertSuccess" class="notification is-success">
							Mensagem enviada com sucesso.
						</div>

				</section>

				<footer class="modal-card-foot">
					<button type="submit" class="button is-success">Enviar</button>
					<button class="button" @click.prevent="goBack">Cancelar</button>
				</footer>

			</form>
			<div class="modal-card-body" v-if="isloading">Carregando</div>
		</div>
	</div>
</template>


<script>

export default {
	data() {
		return {
			nome: '',
			email: '',
			empresa: '',
			mensagem: '',
			isloading:false,
			alertSuccess:false,
		}
	},
	computed: {
		userId() {
			return this.$store.getters.userId;
		},
	},
	methods:{
		goBack(){
			this.$router.push({name:'home'});
		},
		onSubmit(){
			console.log('submit');

			var data = {
				to:'fernando@urlinx.com.br',
				// to:'giannoulakis@gmail.com',
				subject:'Nova mensagem de contato',
				body:'',
			}

			data.body += 'Nome: '+this.nome+'<br>'+"\n";
			data.body += 'Email: '+this.email+'<br>'+"\n";
			data.body += 'Empresa: '+this.empresa+'<br>'+"\n";
			data.body += 'Mensagem: '+this.mensagem+'<br>'+"\n";

			this.$http.get('https://api.scaalar.com/smtp/index.php',{params:data}).then((res)=>{
				console.log(res);
			}).catch((erro)=>{
				console.log(erro);
			});

			this.alertSuccess = true;
			this.nome =  '';
			this.email =  '';
			this.empresa =  '';
			this.mensagem =  '';

		},

	},
	mounted() {

	},
};
</script>


<style>
</style>
